'use client'

import { t } from '@lingui/core/macro'
import { Trans } from '@lingui/react/macro'
import { Link } from '@/lib/i18n/settings'

import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import MuiLink from '@mui/material/Link'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'

import { GettingStartedSection } from './GettingStartedSection'
import { TeleconsultationGuideSection } from './TeleconsultationGuideSection'
import { FaqAndContactSection } from './FaqAndContactSection'

export function HelpPage() {
  return (
    <Box component="main" sx={{ maxWidth: 1000, mx: 'auto', px: { xs: 2, sm: 3 }, pt: 3, pb: 6 }}>
      {/* Hero */}
      <Box sx={{ py: 3 }}>
        <Typography
          variant="h4"
          sx={{
            fontWeight: 800,
            mb: 1,
            backgroundColor: 'primary.main',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
          }}
        >
          <Trans>How can we help you?</Trans>
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ maxWidth: 600 }}>
          <Trans>Find the answers to your questions and learn how to use MedConnect for a better management of your health.</Trans>
        </Typography>
      </Box>

      <GettingStartedSection />
      <TeleconsultationGuideSection />
      <FaqAndContactSection />

      {/* Back navigation */}
      <Box component="nav" aria-label={t`Navigation`} sx={{ mt: 4 }}>
        <MuiLink component={Link} href="/account/dashboard" variant="body2" fontWeight={500} sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.5 }}>
          <ArrowBackIcon sx={{ fontSize: 16 }} />
          <Trans>Back to dashboard</Trans>
        </MuiLink>
      </Box>
    </Box>
  )
}
